// src/utils/ui.js

// PDF 파일 다운로드 / 네이티브 브릿지 호출
export function getPdfFileUrl(dataUrl, fileName) {
    console.log('getPdfFileUrl');
    if (window.webkit?.messageHandlers?.getPdfFileUrl) {
      window.webkit.messageHandlers.getPdfFileUrl.postMessage({ dataUrl, fileName });
    }
    else if (window.Android?.getPdfFileUrl) {
      try { window.Android.getPdfFileUrl(dataUrl, fileName); }
      catch(e){ console.error(e); }
    }
    else {
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
  
  // 갤러리 권한 요청 (Android)
  export function getPermissionGallery(callback) {
    console.log("getPermissionGallery");
    if (window.Android?.requestGalleryPermission) {
      window.onMyPermissionResult = granted => callback(granted);
      try { window.Android.requestGalleryPermission("onMyPermissionResult"); }
      catch(e){ callback(true); }
    }
    else {
      callback(true);  // 웹에서는 바로 허용
    }
  }
  
  // 알림 권한 요청 (Android)
  export function getPermissionNotification(callback) {
    console.log("getPermissionNotification");
    if (window.Android?.requestNotificationPermission) {
      window.onMyPermissionResult = granted => callback(granted);
      try { window.Android.requestNotificationPermission("onMyPermissionResult"); }
      catch(e){ callback(true); }
    }
    else {
      callback(true);
    }
  }
  
  // Blob(Base64) 브릿지 호출
  export function getBase64FromBlobData(data, fileName, callback) {
    if (window.webkit?.messageHandlers?.getBase64FromBlobData) {
      try {
        window.webkit.messageHandlers.getBase64FromBlobData.postMessage({ base64Data: data, fileName });
      }
      catch(e) { callback(e); }
    }
    else if (window.Android?.getBase64FromBlobData) {
      try {
        window.Android.getBase64FromBlobData(data, fileName);
      }
      catch(e) { callback(e); }
    }
    else {
      callback(new Error('Not supported.'));
    }
  }
  


/**
 * 알람 예약 요청 (Android/iOS WebView)
 * @param {number} timeMillis - 알람 예약 시간(밀리초)
 * @param {string} title - 알림 제목
 * @param {string} body - 알림 본문
 */
  export function scheduleNotification(timeMillis, title, body) {
    console.log("scheduleNotification", timeMillis, title, body);
    if (window.Android?.scheduleNotification) {
      try {
        window.Android.scheduleNotification(timeMillis, title, body);
      } catch (e) {
        console.error(e);
      }
    } else if (window.webkit?.messageHandlers?.scheduleNotification) {
      try {
        window.webkit.messageHandlers.scheduleNotification.postMessage({ timeMillis, title, body });
      } catch (e) {
        console.error(e);
      }
    } else {
      console.warn("scheduleNotification is not supported in this environment");
    }
  }
  
